import { ExpenseUnit } from "@/types/expenseUnit";
import { Space, Switch, Tooltip } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ColumnsProps } from "@/components/table";
import { ColumnsType } from "antd/es/table";

type GetColumnsProps = ColumnsProps<ExpenseUnit> & {
  onToggleActive?: (id: string, isActive: boolean) => void;
};

export const getColumns = ({
  onEdit,
  onToggleActive,
  filterOptions,
  filterValues,
  getSortOrder,
}: GetColumnsProps): ColumnsType<ExpenseUnit> => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: true,
    sortOrder: getSortOrder?.("name"),
    filters: filterOptions?.name,
    filterSearch: true,
    filteredValue: filterValues?.name || null,
  },
  {
    title: "Symbol",
    dataIndex: "symbol",
    key: "symbol",
    sorter: true,
    sortOrder: getSortOrder?.("symbol"),
    filters: filterOptions?.symbol,
    filterSearch: true,
    filteredValue: filterValues?.symbol || null,
  },
  {
    title: "Unit Type",
    dataIndex: "unit_type",
    key: "unit_type",
    sorter: true,
    sortOrder: getSortOrder?.("unit_type"),
    filters: filterOptions?.unit_type,
    filterSearch: true,
    filteredValue: filterValues?.unit_type || null,
  },
  {
    title: "Active",
    dataIndex: "is_active",
    key: "is_active",
    sorter: true,
    sortOrder: getSortOrder?.("is_active"),
    render: (isActive: boolean, record: ExpenseUnit) => (
      <Switch
        checked={isActive}
        onChange={(checked) => onToggleActive?.(record.id, checked)}
      />
    ),
  },
  {
    title: "Actions",
    key: "actions",
    width: 100,
    render: (_: any, record: ExpenseUnit) => (
      <Space size="small">
        <Tooltip title="Edit">
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit?.(record)}
            size="small"
          />
        </Tooltip>
      </Space>
    ),
  },
];
